import { render, staticRenderFns } from "./LocalePicker.vue?vue&type=template&id=748f8795&"
import script from "./LocalePicker.js?vue&type=script&lang=js&"
export * from "./LocalePicker.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports